// extracted by mini-css-extract-plugin
export default {"charts":"Widgets_charts__foanf","widgets":"Widgets_widgets__ZAH48","respons":"Widgets_respons__sek-+"};